"use client";

import { Typography } from "@/components/ui/typography";
import type { ServicesFAQProps } from "./types";
import { faqItems } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import {
  FaqStack,
  FaqLinkBlock,
} from "@/components/screen/global-components/faq";

const PricingFAQ = ({ className }: ServicesFAQProps) => {
  return (
    <section className={cn("section", className)}>
      <div className="container mx-auto py-12 lg:py-20">
        <div className="border-b border-gray-300">
          <Typography
            variant="heading4"
            className="text-semantic-text-primary md:text-gray-800"
            asChild
          >
            <h2>Frequently asked questions</h2>
          </Typography>
          <FaqStack items={faqItems} className="mt-6" />
        </div>
        <FaqLinkBlock
          title="Have additional questions? We have answers."
          className="mt-6 py-4 sm:p-0"
        />
      </div>
    </section>
  );
};

export default memo(PricingFAQ);
